<template>
  <el-dialog
    :visible="visible"
    title=""
    width="50rem"
    class="dialog"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <p>尊敬的平台客户：</p>
    <!-- 税务局通知 -->
    <template v-if="showTaxTip">
      <p style="text-indent: 2em">
        收到南昌市税务局通知，南昌市“数电发票”将于
        <span class="text-danger">2023年8月31日</span>
        前全面推行，为提供更好的服务，平台自助开票功能将进行优化升级，达到符合“数电发票“开具条件。平台将在
        <span class="text-danger">2023年8月25日16：00</span>
        后，自助开票功能暂时关闭，期间平台发票不再开具，预计升级完成时间在
        <span class="text-danger">2023年9月10号</span>
        完成，升级完成后，您再进行开票申请，在此期间，给您带来不便请谅解！
      </p>
      <p style="text-indent: 2em">
        如有紧急需要，可联系平台客服4008566100进行线下发票申请。
      </p>
    </template>
    <!-- 税务系统通知 -->
    <template v-if="showSystemTip">
      <p style="text-indent: 2em">
        您好！
      </p>
      <p style="text-indent: 2em">
        我公司的线上开票系统计划于
        <span class="text-danger">2024年2月18日至22日</span>
        进行升级，并转换为数字电子发票系统。在上述日期范围内，现有的开票功能将暂时不可用。
      </p>
      <p style="text-indent: 2em">
        如果您在此期间有任何疑问或需要协助，请随时拨打我们的客服热线：4008655100。
      </p>
      <p style="text-indent: 2em">
        感谢您的理解与支持。
      </p>
    </template>
    <div class="flex row-center">
      <el-button type="primary" @click="closeDialog">我知道了</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'InvoiceNoticeDialog',

  data() {
    return {
      visible: false,

      showTaxTip: false,

      showSystemTip: true
    }
  },

  methods: {
    closeDialog() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped lang="scss">
.text-danger {
  color: $danger-color;
}
</style>
